import React from "react";
import UserDataGrid from "./UserDataGrid";

const UsersNRoles = () => {
  return (
    <div className="">
      <UserDataGrid />
    </div>
  );
};

export default UsersNRoles;
